import {
    acceptMeetingRequestButton,
    tentativelyAcceptMeetingRequestButton,
    declineMeetingRequestButton,
} from './MeetingRequestActions.locstring.json';
import loc from 'owa-localize';
import MeetingActionButton from './MeetingActionButton';
import ProposeNewTimeButton from './ProposeNewTimeButton';
import respondToMeeting from '../actions/respondToMeeting';
import { MeetingRequestViewState } from '../store/schema/MeetingRequestViewState';
import { default as logMeetingMessageAction } from '../utils/logMeetingMessageAction';
import MeetingMessageActionEntrySource from '../store/schema/MeetingMessageActionEntrySource';
import { observer } from 'mobx-react';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import { ControlIcons } from 'owa-control-icons';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

import * as React from 'react';

export interface MeetingRequestActionsProps {
    item: MeetingRequestMessageType;
    viewState: MeetingRequestViewState;
    entrySource: MeetingMessageActionEntrySource;
    onActionButtonClicked?: () => void;
}

@observer
export default class MeetingRequestActions extends React.Component<MeetingRequestActionsProps, {}> {
    render() {
        const { item, entrySource } = this.props;

        return (
            <FocusZone direction={FocusZoneDirection.horizontal}>
                <MeetingActionButton
                    key="accept"
                    iconProps={{
                        iconName: ControlIcons.Accept,
                    }}
                    text={loc(acceptMeetingRequestButton)}
                    onClick={this.onMeetingActionButtonClick('Accept')}
                    {...this.props}
                />
                <MeetingActionButton
                    key="tentative"
                    iconProps={{
                        iconName: ControlIcons.Help,
                    }}
                    text={loc(tentativelyAcceptMeetingRequestButton)}
                    onClick={this.onMeetingActionButtonClick('Tentative')}
                    {...this.props}
                />
                <MeetingActionButton
                    key="decline"
                    iconProps={{
                        iconName: ControlIcons.Cancel,
                    }}
                    text={loc(declineMeetingRequestButton)}
                    onClick={this.onMeetingActionButtonClick('Decline')}
                    {...this.props}
                />
                {this.canProposeNewTime(item) && (
                    <ProposeNewTimeButton
                        key="proposeNewTime"
                        item={item}
                        entrySource={entrySource}
                    />
                )}
            </FocusZone>
        );
    }

    private onMeetingActionButtonClick = (
        responseType: 'Accept' | 'Tentative' | 'Decline'
    ) => () => {
        const {
            item,
            viewState: {
                editorViewState: { sendResponse, content },
            },
            entrySource,
        } = this.props;
        if (item.IsResponseRequested) {
            respondToMeeting(item, responseType, sendResponse, this.props.viewState, content);
        } else {
            respondToMeeting(item, responseType, false, this.props.viewState);
        }
        const additionalProps = [];
        if (content !== '<div></div>') {
            additionalProps.push('HasMessage');
        }
        if (sendResponse) {
            additionalProps.push('NotifyOrganizer');
        }
        logMeetingMessageAction(responseType, item, entrySource, additionalProps);
        if (this.props.onActionButtonClicked) {
            this.props.onActionButtonClicked();
        }
    };

    private canProposeNewTime(item: MeetingRequestMessageType): boolean {
        return (
            item.IsResponseRequested &&
            item.__type === 'MeetingRequestMessageType:#Exchange' &&
            item.AssociatedCalendarItemId &&
            !item.IsAllDayEvent &&
            (!item.IsRecurring || item.CalendarItemType != 'RecurringMaster') &&
            !isConsumer() &&
            this.props.viewState.showProposeNewTime
        );
    }
}
